module.exports = __webpack_public_path__ + "media/cupraborn.682f43ce.mp4";